<template>
    <div>
        <div
            v-if="currentProgressBarPercent && currentProgressBar?.title?.length"
            class="rounded-3 align-items-center between-cart__progress bg-grey-light pt-3 pb-2 px-3 mb-3"
            data-cy="free-delivery-bar"
        >
            <div
                class="fs-15 fwb mb-md-0 pe-3 mt-0 mb-3 mb-md-0"
                v-html="
                    currentProgressBar?.title?.replace('%amount%', $formatCurrency(currentProgressBar?.price - basket.price.productPrice))
                "
            />
            <div class="between-cart__progress-bar col">
                <div class="between-cart__progress-rounded d-flex justify-content-between">
                    <span class="pe-3">
                        <strong
                            class="notranslate"
                            data-cy="to-free-delivery"
                            v-html="`${$formatCurrency(currentProgressBar?.price - basket.price.productPrice)}`"
                        />
                    </span>
                    <span class="text-right fwb d-flex align-items-end notranslate" v-html="$formatCurrency(currentProgressBar?.price)" />
                </div>

                <div class="progress-bar-wrapper">
                    <div
                        class="progress-bar col-md-6 bg-success rounded"
                        role="progressbar"
                        :style="`width: ${currentProgressBarPercent}%; height: 6px;`"
                        :aria-valuenow="currentProgressBarPercent"
                        aria-valuemin="0"
                        aria-valuemax="100"
                    ></div>
                </div>
            </div>
        </div>
        <div
            v-else-if="basket.freeDelivery.isEnabled && basket.freeDelivery.isFree"
            class="between-cart__free-shipping py-2 px-2 text-center fs-16 fwb mb-4"
        >
            <img width="18" height="18" src="/nuxt-assets/images/icons/check-green.svg" class="me-2 d-inline-block" loading="lazy" />
            {{ $t('prebasket.freeShipping') }}
        </div>
        <div
            v-else-if="basket.discountedDelivery.isEnabled && basket.discountedDelivery.isDiscounted"
            class="between-cart__free-shipping py-2 px-2 text-center fs-16 fwb mb-4"
        >
            <img width="18" height="18" src="/nuxt-assets/images/icons/check-green.svg" class="me-2 d-inline-block" loading="lazy" />
            {{ $t('prebasket.discountedShipping') }}
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useBasketStore } from '~/stores/basket'
import ProgressBar from '~/models/ProgressBar'

const basket = computed(() => {
    const basketStore = useBasketStore()

    return basketStore.basket
})

const currentProgressBar = computed((): ProgressBar | null => {
    const basketStore = useBasketStore()

    const progressBars = basketStore.progressBars
    for (let i = 0; i < progressBars.length; i++) {
        if (basket.value.price.productPrice < progressBars[i].price) {
            return progressBars[i]
        }
    }

    return null
})

const currentProgressBarPercent = computed(() => {
    if (currentProgressBar.value === null) {
        return null
    }

    return Math.min((basket.value.price.productPrice / currentProgressBar.value.price) * 100, 100)
})
</script>

<style lang="scss" scoped>
.progress-bar-wrapper {
    border-radius: 2px 0 0 2px;
    margin: 0 15px 10px 0;
    background-color: #fff;
    position: relative;

    &:after {
        position: absolute;
        right: -15px;
        top: -6px;
        content: url('/nuxt-assets/images/icons/check-green.svg');
    }
}

.between-cart {
    &__free-shipping {
        background-color: #ecf4d9;
        color: $color-green-dark;
        border-radius: 50px;

        img {
            margin-top: -4px;
        }
    }
}

.box-delivery-free {
    padding: 2em;
    position: relative;

    .between-cart__progress-bar {
        grid-template-columns: auto 75px;
    }

    .between-cart__progress {
        margin-top: -10px;
    }

    .ico {
        position: absolute;
        right: -32px;
        top: -15px;
    }

    @include screen-md {
        .box-free-delivery-from {
            margin-top: 10px;
        }
        .box-delivery-free-left {
            margin-top: -3px;
        }
    }

    @media (max-width: $screen-md) {
        .box-free-delivery-from {
            margin-top: 1.5em;
        }
        .box-delivery-free-left {
            position: absolute;
            bottom: 20px;
        }

        .between-cart__progress-bar {
            display: block;
        }
    }
}

.between-cart {
    &__progress {
        display: grid;
        grid-template-columns: 270px auto;
        align-self: end;

        @media (max-width: $screen-sm) {
            display: block;
        }
    }

    &__progress-rounded {
        border-radius: 2px 0 0 2px;
        margin: 0 0 10px 0;
    }
}
</style>
